import React from "react";

const MenuTextHolder = ({ title, onClick, link }) => {
    return (
        <div
            onClick={onClick}
            className="cursor-pointer font-semibold text-[14px] px-4 py-2 leading-5 text-[#595959] dark:text-white"
        >
            {link && (
                <a href={link} target="_blank" rel="noopener noreferrer">
                    {title}
                </a>
            )}
            {!link && (
                <div className=" leading-5 text-[#595959] dark:text-white">
                    {title}
                </div>
            )}
        </div>
    );
};

export default MenuTextHolder;
